import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../Icon';
import './style.scss';
var defaultButtons = {
  goToFirstPageButton: /*#__PURE__*/React.createElement(Icon, {
    name: "first_page",
    flair: "filled"
  }),
  goToPreviousPageButton: /*#__PURE__*/React.createElement(Icon, {
    name: "chevron_left",
    flair: "filled"
  }),
  goToNextPageButton: /*#__PURE__*/React.createElement(Icon, {
    name: "chevron_right",
    flair: "filled"
  }),
  goToLastPageButton: /*#__PURE__*/React.createElement(Icon, {
    name: "last_page",
    flair: "filled"
  }),
  zoomInButton: /*#__PURE__*/React.createElement(Icon, {
    name: "zoom_in",
    flair: "filled"
  }),
  zoomOutButton: /*#__PURE__*/React.createElement(Icon, {
    name: "zoom_out",
    flair: "filled"
  }),
  download: /*#__PURE__*/React.createElement(Icon, {
    name: "download",
    flair: "filled"
  }),
  print: /*#__PURE__*/React.createElement(Icon, {
    name: "print",
    flair: "filled"
  })
};
var MIN_ZOOM = 0.6;
var MAX_ZOOM = 2.0;
var ZOOM_STEP = 0.1;
var ControlPanel = function ControlPanel(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var file = props.file,
    pageNumber = props.pageNumber,
    numPages = props.numPages,
    setPageNumber = props.setPageNumber,
    scale = props.scale,
    setScale = props.setScale,
    _props$goToFirstPageB = props.goToFirstPageButton,
    goToFirstPageButton = _props$goToFirstPageB === void 0 ? defaultButtons.goToFirstPageButton : _props$goToFirstPageB,
    _props$goToPreviousPa = props.goToPreviousPageButton,
    goToPreviousPageButton = _props$goToPreviousPa === void 0 ? defaultButtons.goToPreviousPageButton : _props$goToPreviousPa,
    _props$goToNextPageBu = props.goToNextPageButton,
    goToNextPageButton = _props$goToNextPageBu === void 0 ? defaultButtons.goToNextPageButton : _props$goToNextPageBu,
    _props$goToLastPageBu = props.goToLastPageButton,
    goToLastPageButton = _props$goToLastPageBu === void 0 ? defaultButtons.goToLastPageButton : _props$goToLastPageBu,
    _props$zoomInButton = props.zoomInButton,
    zoomInButton = _props$zoomInButton === void 0 ? defaultButtons.zoomInButton : _props$zoomInButton,
    _props$zoomOutButton = props.zoomOutButton,
    zoomOutButton = _props$zoomOutButton === void 0 ? defaultButtons.zoomOutButton : _props$zoomOutButton,
    _props$downloadButton = props.downloadButton,
    downloadButton = _props$downloadButton === void 0 ? defaultButtons.download : _props$downloadButton,
    _props$printButton = props.printButton,
    printButton = _props$printButton === void 0 ? defaultButtons.print : _props$printButton,
    dualPage = props.dualPage;
  var isFirstPage = pageNumber === 1;
  var isLastPage = pageNumber === numPages;
  var firstPageClass = isFirstPage ? 'disabled' : 'clickable';
  var lastPageClass = isLastPage ? 'disabled' : 'clickable';
  var pageOffset = dualPage ? 2 : 1;
  var goToFirstPage = function goToFirstPage() {
    if (!isFirstPage) setPageNumber(1);
  };
  var goToPreviousPage = function goToPreviousPage() {
    if (!isFirstPage) setPageNumber(pageNumber - pageOffset);
  };
  var goToNextPage = function goToNextPage() {
    if (!isLastPage) setPageNumber(pageNumber + pageOffset);
  };
  var goToLastPage = function goToLastPage() {
    if (!isLastPage) setPageNumber(numPages);
  };
  var onPageChange = function onPageChange(e) {
    var value = e.target.value;
    if (Number(value) <= 0 || Number(value) > numPages) return;
    setPageNumber(Number(value));
  };
  useEffect(function () {
    var handleKeyDown = function handleKeyDown(event) {
      switch (event.key) {
        case 'ArrowRight':
        case 'n':
          if (pageNumber < numPages) setPageNumber(pageNumber + pageOffset);
          break;
        case 'ArrowLeft':
        case 'p':
          if (pageNumber > 1) setPageNumber(pageNumber - pageOffset);
          break;
        case '+':
        case '=':
          setScale(scale + 0.1);
          break;
        case '-':
        case '_':
          if (scale > 0.1) setScale(scale - 0.1);
          break;
        case '0':
        case ')':
          setScale(1);
          break;
        default:
          break;
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return function () {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [pageNumber, numPages, scale, setScale, setPageNumber, pageOffset]);
  var isMinZoom = scale < MIN_ZOOM;
  var isMaxZoom = scale >= MAX_ZOOM;
  var zoomOutClass = isMinZoom ? 'disabled' : 'clickable';
  var zoomInClass = isMaxZoom ? 'disabled' : 'clickable';
  var zoomOut = function zoomOut() {
    if (!isMinZoom) setScale(scale - ZOOM_STEP);
  };
  var zoomIn = function zoomIn() {
    if (!isMaxZoom) setScale(scale + ZOOM_STEP);
  };
  var print = function print() {
    var pdfFrame = document.createElement('iframe');
    pdfFrame.style.visibility = 'hidden';
    pdfFrame.src = file;
    document.body.appendChild(pdfFrame);
    if (pdfFrame.contentWindow) {
      pdfFrame.contentWindow.focus();
      pdfFrame.contentWindow.print();
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "ControlPanel"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ControlPanel__pageControl"
  }, /*#__PURE__*/React.createElement("button", {
    className: firstPageClass,
    onClick: goToFirstPage,
    type: "button",
    id: "PDFReader__firstPageButton"
  }, goToFirstPageButton), /*#__PURE__*/React.createElement("button", {
    className: firstPageClass,
    onClick: goToPreviousPage,
    type: "button",
    id: "PDFReader__previousPageButton"
  }, goToPreviousPageButton), /*#__PURE__*/React.createElement("span", {
    className: "ControlPanel__pageControl__pageIndicator"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ControlPanel__pageControl__pageIndicator__current"
  }, t('components.pdfreader.page')), /*#__PURE__*/React.createElement("input", {
    name: "pageNumber",
    type: "number",
    min: 1,
    step: dualPage ? 2 : 1,
    max: numPages || 1,
    value: pageNumber,
    onChange: onPageChange
  }), /*#__PURE__*/React.createElement("span", {
    className: "ControlPanel__pageControl__pageIndicator__total"
  }, t('components.pdfreader.of'), " ", numPages)), /*#__PURE__*/React.createElement("button", {
    className: lastPageClass,
    onClick: goToNextPage,
    type: "button",
    id: "PDFReader__nextPageButton"
  }, goToNextPageButton), /*#__PURE__*/React.createElement("button", {
    className: lastPageClass,
    onClick: goToLastPage,
    type: "button",
    id: "PDFReader__lastPageButton"
  }, goToLastPageButton)), /*#__PURE__*/React.createElement("div", {
    className: "ControlPanel__pageControl"
  }, /*#__PURE__*/React.createElement("button", {
    className: zoomOutClass,
    onClick: zoomOut,
    type: "button",
    id: "PDFReader__zoomOutButton"
  }, zoomOutButton), /*#__PURE__*/React.createElement("span", {
    className: "ControlPanel__pageControl__zoomLevel"
  }, (scale * 100).toFixed(), "%"), /*#__PURE__*/React.createElement("button", {
    className: zoomInClass,
    onClick: zoomIn,
    type: "button",
    id: "PDFReader__zoomInButton"
  }, zoomInButton)), /*#__PURE__*/React.createElement("div", {
    className: "ControlPanel__pageControl"
  }, /*#__PURE__*/React.createElement("a", {
    href: file,
    download: "download"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    id: "PDFReader__downloadButton"
  }, downloadButton)), /*#__PURE__*/React.createElement("button", {
    className: "clickable",
    onClick: print,
    type: "button",
    id: "PDFReader__printButton"
  }, printButton)));
};
export default ControlPanel;